module.exports = __webpack_public_path__ + "img/Gauge-Rotor_Force_Direction-Plate_img01.dd03a984.svg";